import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// RC Well drill-in selection — DOCUMENT-SCOPED (atomFamily keyed on documentId),
// mirror of DO's layout atom. A well is addressed by its position in the
// overview list (index), not by id, so the shell can title the drill-in
// ("Well N of M") without holding the row. Intentionally NOT a module-level
// singleton — that would leak selection across documents.
export const selectedWellIndexAtom = atomFamily(
  (_documentId: number | string) => atom<number | null>(null)
);

// Line Item Review drill-in selection — DOCUMENT-SCOPED, independent of the Well
// section's selection above. A well GROUP is addressed by its position in the
// line-item overview list (index), so the shell can title the drill-in and
// page prev/next without holding the group.
export const selectedLineItemWellIndexAtom = atomFamily(
  (_documentId: number | string) => atom<number | null>(null)
);
